// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\NotificationResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type NotificationApiResponse = {
	id: number;
	event: string;
	transactionId: string;
	createdAt: string;
	data: Record<string, string>;
	isRead: boolean;
};

export type Notification = {
	id: number;
	event: string;
	transactionId: string;
	createdAt: DateTime;
	data: Record<string, string>;
	isRead: boolean;
};

export function hydrateNotification(data: NotificationApiResponse): Notification {
	return {
		...data,
		createdAt: DateTimefromISO(data.createdAt)!,
		data: Array.isArray(data.data) ? {} : data.data,
	};
}